import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import BSpinner from "../../../components/spinners/BSpinner";
import EditCoworkerForm from "../../../forms/EditCoworkerForm";
import { coworkersService } from "../../../service/coworkersService";

export default function CoworkersEditPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [responseErrors, setResponseErrors] = useState();
  const { id } = useParams();
  const [coworker, setCoworker] = useState();
  const history = useHistory();

  useEffect(() => {
    setIsLoading(true);
    setResponseErrors([]);
    
    coworkersService
      .getCoworkerById(id)
      .then((res) => setCoworker(res.data))
      .catch((err) => {
        if (!err.response || err.response.status === 404) {
          history.push("/coworkers");
        }
      })
      .finally((_) => {
        setIsLoading(false);
      });
  }, [id]);

  const handleSubmit = (data) => {
    setIsLoading(true);
    setResponseErrors([]);

    coworkersService
      .updateCoworker(id, data)
      .then(() => {
        history.push(`/coworkers/${id}`);
      })
      .catch((err) => {
        setResponseErrors(err.response.data);
      });
  };

  if (isLoading) {
    return <BSpinner />;
  }

  return (
    <div className="m-6 bg-white border-gray-400 rounded shadow-md">
      <EditCoworkerForm
        isNew={false}
        onSubmit={handleSubmit}
        preloadedData={coworker}
        btnText="Speichern"
        responseErrors={responseErrors}
      />
    </div>
  );
}
